
  import { stringify } from 'qs';
  export default {
    props: { props: { type: Object, required: true } },
    methods: {
      pathForPage (page) {
        if (page === 1) {
          return this.$route.path;
        } else {
          return `${this.$route.path}/?${stringify({ ...this.$route.query, ...{ page } })}`.replace(/\/+/g, '/');
        }
      },
      cssClass (page) {
        if (this.props.pageClasses(page).match('active')) {
          return 'active';
        }
      }
    }
  };
